<template>
  <div class="result">
    <app-container>
      <h1 class="result__title">
        Ваш результат
      </h1>
      <div class="page-grid">
        <div class="page-grid__content">
          <div style="display: flex; justify-content: space-between">
            <div class="user-info">
              <span class="user-info__item"><icon-user class="user-info__icon"/>{{ result.name }}</span>
              <span class="user-info__item"><icon-email class="user-info__icon"/>{{ result.email }}</span>
              <span class="user-info__item"><icon-phone class="user-info__icon"/>{{ result.phone }}</span>
            </div>
            <div
              v-if="test && test.testResult.showAveragePercent"
              class="average-percent"
            >
              {{ averagePercent }} %
            </div>
          </div>
          <app-button
            class="result__button"
            type="button"
            @click.native="print"
          >
            Скачать .PDF
          </app-button>
          <test-result
            class="result__test-result"
            :results="result.categories"
          />
        </div>
        <img
          class="page-grid__image"
          src="@/assets/images/result-bg.svg"
        >
      </div>
      <additional-info :results="result.categories" />
      <h1 class="result__title_second">
        {{ test ? test.testResult.resultsTitle : '' }}
      </h1>
      <div class="result__cards">
        <div
          v-for="(item, index) in resultsRange"
          :key="index"
          class="cards-list__item"
        >
          <result-card
            :cards="item"
          />
        </div>
      </div>
      <div v-if="test && test.testResult && test.testResult.bottomText">
        <h2 class="result__title_second">
          {{ test.testResult.bottomTextTitle }}
        </h2>
        <p v-html="test.testResult.bottomText" />
      </div>
    </app-container>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import AppContainer from '../components/Base/AppContainer';
import IconUser from '../components/Icons/IconUser';
import IconEmail from '../components/Icons/IconEmail';
import IconPhone from '../components/Icons/IconPhone';
import AppButton from '../components/Base/AppButton';
import TestResult from '../components/Forms/TestResult';
import ResultCard from '../components/Cards/ResultCard';
import AdditionalInfo from '../components/Forms/AdditionalInfo';

export default {
  name: 'Result',
  components: {
    AdditionalInfo,
    AppContainer,
    AppButton,
    IconUser,
    IconEmail,
    IconPhone,
    TestResult,
    ResultCard,
  },
  data() {
    return {
      result: '',
    };
  },
  computed: {
    ...mapGetters('results', ['getResult']),
    ...mapState('tests', ['test']),
    resultsRange() {
      return this.result.results.slice(0, 3);
    },
    averagePercent() {
      if (!this.result.categories.length) {
        return 0;
      }
      const percent = this.result.categories.reduce((acc, current) => acc + current.percent, 0) / this.result.categories.length;
      return Math.ceil(percent);
    },
  },
  watch: {
    // eslint-disable-next-line object-shorthand
    'result.testId'(val) {
      if (!this.test && val) {
        this.$store.dispatch('tests/loadById', val);
      }
    },
  },
  created() {
    try {
      const userId = this.$route.params.rid;
      this.loadResult(userId);
      this.getInfoResult();
    } catch (error) {
      console.log(error);
    }
  },
  mounted() {
    window.addEventListener('beforeprint', this.onBeforePrint);
    window.addEventListener('afterprint', this.onAfterPrint);
  },
  beforeDestroy() {
    window.removeEventListener('beforeprint', this.onBeforePrint);
    window.removeEventListener('afterprint', this.onAfterPrint);
  },
  methods: {
    ...mapActions('results', ['loadResult']),
    getInfoResult() {
      this.result = this.getResult;
    },
    print() {
      window.print();
    },
    onBeforePrint() {
      document.querySelector('.app-header').style.display = 'none';
      document.querySelector('.result').style.padding = '0';
      document.querySelector('.footer').style.display = 'none';
    },
    onAfterPrint() {
      document.querySelector('.app-header').style.display = 'block';
      document.querySelector('.result').style.padding = '100px';
      document.querySelector('.footer').style.display = 'block';
    },
  },
};
</script>

<style lang="scss" scoped>
  .page-grid {
    page-break-after: always;
  }
  .average-percent {
    color: #F46D0C;
    font-weight: 800;
    font-size: 80px;
    margin-right: 60px;
  }
  .page-grid__image {
    max-width: calc(100% + 70px);
    margin-left: -70px;
    z-index: -1;
  }
  .result {
    padding: 100px 0;
    display: flex;
    &__cards {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
      grid-gap: 20px;
    }
    &__button {
      margin: 25px 0;
      @media print {
        display: none;
      }
    }
    &__test-result {
      margin: 50px 0;
      align-content: center;
      page-break-after: always;
      @media print {
        margin-left: 100px;
      }
    }
    &__title {
      &_second {
        @media print {
          display: none;
        }
      }
    }
    &__cards {
      @media print {
        transform: rotate(90deg);
        margin: 400px 100px 0 0;
      }
    }
  }

  .user-info {
    display: flex;
    flex-direction: column;
    font-size: 19px;
    &__icon {
      width: 20px;
      height: 20px;
      margin-right: 15px;
    }
    &__item {
      padding: 5px 0;
      align-content: center;
    }
  }

  .cards-list {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    list-style-type: none;
    padding: 0;
    margin: 0;
  }

  @media screen and (max-width: $window-md) {
    .result {
      &__test-result {
        width: auto;
      }
      &__title {
        &_second {
          text-align: center;
        }
      }
    }
    .cards-list {
      align-items: center;
      flex-direction: column;
    }
  }

  @media screen and (max-width: $window-sm) {
    .result {
      &__test-result {
        width: 100%;
      }
      &__title {
        font-size: 20px;
      }
      &__title {
        &_second {
          margin: 0;
          text-align: left;
          font-size: 28px;
        }
      }
    }
    .cards-list {
      flex-direction: column;
    }
  }
</style>
